import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BUILD_INFO } from '../build-info.generated';

interface BuildInfo {
    version: string;
    revision: string;
    builtAt: string;
    buildId: string;
}

interface ReleaseNote {
    version: string;
    publishedAt: string;
    title: string;
    changes: string[];
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
    currentDate: Date = new Date();
    buildInfo: BuildInfo = BUILD_INFO;
    releases: ReleaseNote[] = [];
    checkingBuild = true;
    updateAvailable = false;
    buildCheckUnavailable = false;
    loadingReleases = false;
    releasesUnavailable = false;

    constructor(
        private http: HttpClient,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {
        this.checkPublishedBuild();
    }

    openReleases(content: TemplateRef<any>): void {
        this.loadReleases();
        this.modalService.open(content, { centered: true, size: 'lg', scrollable: true });
    }

    reloadApplication(): void {
        window.location.reload();
    }

    private checkPublishedBuild(): void {
        this.getWithoutCache<BuildInfo>('assets/build-info.json').subscribe(
            publishedBuild => {
                this.updateAvailable = publishedBuild.buildId !== this.buildInfo.buildId;
                this.checkingBuild = false;
            },
            () => {
                this.checkingBuild = false;
                this.buildCheckUnavailable = true;
            }
        );
    }

    private loadReleases(): void {
        this.loadingReleases = true;
        this.releasesUnavailable = false;

        this.getWithoutCache<ReleaseNote[]>('assets/releases.json').subscribe(
            releases => {
                this.releases = releases;
                this.loadingReleases = false;
            },
            () => {
                this.loadingReleases = false;
                this.releasesUnavailable = true;
            }
        );
    }

    private getWithoutCache<T>(url: string) {
        return this.http.get<T>(url, {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache'
            }),
            params: new HttpParams().set('t', Date.now().toString())
        });
    }
}
